/**
 * バリデーションエラー情報（メッセージID形式）
 *
 * @typedef {{ messageId: string; args: string[] }} ValidationErrorItem
 */

/**
 * 判定ルール設定のバリデーションを実行 戻り値の serverErrors / clientErrors は getMessage(messageId, ...args) で表示用文字列に変換すること
 *
 * @param {Object} state - ストアの状態
 * @returns {{
 *   isError: boolean
 *   clientErrors: Object<string, ValidationErrorItem>
 *   serverErrors: ValidationErrorItem[]
 * }}
 */
export const runValidation = (state) => {
  const clientErrors = {}
  const serverErrors = []
  const hasServerError = (messageId, argsStr) =>
    serverErrors.some((e) => e.messageId === messageId && JSON.stringify(e.args) === argsStr)

  // ルール名の必須チェック
  if (!state.ruleName || state.ruleName.trim() === '') {
    const item = { messageId: 'E010001', args: ['ルール名'] }
    clientErrors.ruleName = item
    if (!hasServerError('E010001', JSON.stringify(['ルール名']))) serverErrors.push(item)
  }

  // ルール名の最大文字数チェック
  if (state.ruleName && state.ruleName.length > 100) {
    const item = { messageId: 'E010006', args: ['ルール名', '100'] }
    clientErrors.ruleName = item
    if (!hasServerError('E010006', JSON.stringify(['ルール名', '100']))) serverErrors.push(item)
  }

  // 対象期間の必須チェック
  if (
    !state.periodKind ||
    (state.periodKind !== 'monthly' && state.periodKind !== 'quarter' && state.periodKind !== 'yearly')
  ) {
    const item = { messageId: 'E010017', args: ['対象期間'] }
    clientErrors.periodKind = item
    if (!hasServerError('E010017', JSON.stringify(['対象期間']))) serverErrors.push(item)
  }

  // データ分類の必須チェック
  if (!state.targetCategory || state.targetCategory.trim() === '') {
    const item = { messageId: 'E010017', args: ['判定結果の設定先（データ分類とデータ項目）'] }
    clientErrors.targetCategory = item
    if (!hasServerError('E010017', JSON.stringify(item.args))) serverErrors.push(item)
  }

  // データ項目の必須チェック
  if (!state.targetField || state.targetField.trim() === '') {
    const item = { messageId: 'E010017', args: ['判定結果の設定先（データ分類とデータ項目）'] }
    clientErrors.targetField = item
    if (!hasServerError('E010017', JSON.stringify(item.args))) serverErrors.push(item)
  }

  // 判定ルールの必須チェック
  if (!state.judgmentRules || state.judgmentRules.length === 0) {
    const item = { messageId: 'E011017', args: ['判定ルール'] }
    clientErrors.judgmentRules = item
    serverErrors.push(item)
  } else {
    // 各判定ルールの条件式の必須チェック（判定結果は空を許容）
    const conditionItem = { messageId: 'E010001', args: ['条件式'] }
    let conditionPushed = false
    state.judgmentRules.forEach((rule, index) => {
      if (!rule.condition || rule.condition.trim() === '') {
        clientErrors[`judgmentRules.${index}.condition`] = conditionItem
        if (!conditionPushed) {
          serverErrors.push(conditionItem)
          conditionPushed = true
        }
      }
    })
  }

  // 有効期間の相関チェック
  if (state.validStartMonth && state.validEndMonth) {
    if (state.validStartMonth > state.validEndMonth) {
      const item = { messageId: 'E011020', args: ['有効期間'] }
      clientErrors.validPeriod = item
      serverErrors.push(item)
    }
  }

  return {
    isError: Object.keys(clientErrors).length > 0 || serverErrors.length > 0,
    clientErrors,
    serverErrors
  }
}
